export const COMPARADOR_SET_ITEMS_TO_COMPARE_SUCCESS = 'COMPARADOR_SET_ITEMS_TO_COMPARE_SUCCESS';
export const COMPARADOR_LOAD_SCHEMA_TO_COMPARE = 'COMPARADOR_LOAD_SCHEMA_TO_COMPARE';
export const COMPARADOR_CLEAR_VEHICLE_DETAIL_TO_COMPARE = 'COMPARADOR_CLEAR_VEHICLE_DETAIL_TO_COMPARE';

export const COMPARADOR_REMOVE_ITEMS_TO_COMPARE = 'COMPARADOR_REMOVE_ITEMS_TO_COMPARE';

export const COMPARADOR_LOAD_BRANDS_BEGIN = 'COMPARADOR_LOAD_BRANDS_BEGIN';
export const COMPARADOR_LOAD_BRANDS_SUCCESS = 'COMPARADOR_LOAD_BRANDS_SUCCESS';
export const COMPARADOR_LOAD_BRANDS_FAILURE = 'COMPARADOR_LOAD_BRANDS_FAILURE';

export const COMPARADOR_LOAD_MODELS_BEGIN = 'COMPARADOR_LOAD_MODELS_BEGIN';
export const COMPARADOR_LOAD_MODELS_SUCCESS = 'COMPARADOR_LOAD_MODELS_SUCCESS';
export const COMPARADOR_LOAD_MODELS_FAILURE = 'COMPARADOR_LOAD_MODELS_FAILURE';

export const COMPARADOR_LOAD_YEARS_BEGIN = 'COMPARADOR_LOAD_YEARS_BEGIN';
export const COMPARADOR_LOAD_YEARS_SUCCESS = 'COMPARADOR_LOAD_YEARS_SUCCESS';
export const COMPARADOR_LOAD_YEARS_FAILURE = 'COMPARADOR_LOAD_YEARS_FAILURE';

export const COMPARADOR_LOAD_VERSIONS_BEGIN = 'COMPARADOR_LOAD_VERSIONS_BEGIN';
export const COMPARADOR_LOAD_VERSIONS_SUCCESS = 'COMPARADOR_LOAD_VERSIONS_SUCCESS';
export const COMPARADOR_LOAD_VERSIONS_FAILURE = 'COMPARADOR_LOAD_VERSIONS_FAILURE';

export const COMPARADOR_LOAD_VEHICLES_BEGIN = 'COMPARADOR_LOAD_VEHICLES_BEGIN';
export const COMPARADOR_LOAD_VEHICLES_SUCCESS = 'COMPARADOR_LOAD_VEHICLES_SUCCESS';
export const COMPARADOR_LOAD_VEHICLES_FAILURE = 'COMPARADOR_LOAD_VEHICLES_FAILURE';

export const COMPARADOR_OPEN_MODAL_FORM = 'COMPARADOR_OPEN_MODAL_FORM';